var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPaymentsActiveIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Dashboard_NavIcon_VerNet"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Pay_NavIcon_VerNet",
    clipPath: "url(#clip0_1074_187532)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Pay_NavIcon_VerNet_2",
    clipPath: "url(#clip1_1074_187532)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M18.7197 6.47034H7.42969L16.4197 3.06034C16.9097 2.88034 17.4597 3.13034 17.6397 3.62034L18.7197 6.47034Z",
    fill: "#0C0C0E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M18.93 8.4707H5.05C4.47 8.4707 4 8.9307 4 9.5107V18.9507C4 19.5307 4.47 20.0007 5.05 20.0007H18.93C19.51 20.0007 19.98 19.5307 19.98 18.9507V17.1307H13.17C11.54 17.1307 10.21 15.8007 10.21 14.1607C10.21 12.5207 11.54 11.2007 13.17 11.2007H19.98V9.5107C19.98 8.9307 19.51 8.4707 18.93 8.4707ZM11.21 14.1607C11.21 15.2407 12.09 16.1307 13.17 16.1307H19.98V12.2007H13.17C12.09 12.2007 11.21 13.0807 11.21 14.1607ZM14.39 14.1607C14.39 14.6807 13.97 15.1007 13.45 15.1007C12.93 15.1007 12.51 14.6807 12.51 14.1607C12.51 13.6407 12.93 13.2207 13.45 13.2207C13.97 13.2207 14.39 13.6407 14.39 14.1607Z",
    fill: "#0C0C0E"
  }))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1074_187532"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(4 4)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1074_187532"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.98,
    height: 17,
    fill: "white",
    transform: "translate(4 3)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentsActiveIcon);
export default __webpack_public_path__ + "static/media/payments-active-icon.e9d6afdc82df7cc61c754694f9f24024.svg";
export { ForwardRef as ReactComponent };